import { WebViewerInstance } from '@pdftron/webviewer';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { pdfSearch } from '../data/actions';
import { getSearchQuery } from '../data/reducer';

/**
 * Keeps PDFTron full-document search in sync with the viewer Redux `searchQuery`.
 *
 * URL parameters (e.g. print text search) are read in the viewer page saga, which
 * dispatches `pdfSearch.request` so the query lives in Redux; this hook applies it
 * via `instance.UI.searchTextFull` once WebViewer is ready.
 *
 * @see `modules/viewerPage/data/sagas.js` — `pdfSearch.request` from `printTextSearch`
 */
export const useSearchQuery = ({
  instance,
}: {
  instance: WebViewerInstance | null;
}) => {
  const dispatch = useDispatch();
  const searchQuery = useSelector(getSearchQuery);

  useEffect(() => {
    if (instance && searchQuery) {
      instance.UI.searchTextFull(searchQuery);
      dispatch(pdfSearch.success());
    }
  }, [dispatch, instance, searchQuery]);
};
